<div class="row">
  <div class="col-md-9">
    <h1 mat-dialog-title>Create TDU Rates</h1>
  </div>
  <div class="col-md-3">
    <span class="pull-right f-13" (click)="closeDialog()"> X </span>
  </div>
</div>
<div mat-dialog-content>
  <form [formGroup]="tduRatesForm" role="form">
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Abbreviation</label>
        <input
          type="text"
          class="form-control"
          formControlName="abbreviation"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label"> Code</label>
        <input type="text" class="form-control" formControlName="code" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">IstaId</label>
        <input type="text" class="form-control" formControlName="istaId" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">MoveInFee</label>
        <input type="text" class="form-control" formControlName="moveInFee" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">PriorityMoveInFee</label>
        <input
          type="text"
          class="form-control"
          formControlName="priorityMoveInFee"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">SwitchFee</label>
        <input type="text" class="form-control" formControlName="switchFee" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">TypeOfTDU</label>
        <input type="text" class="form-control" formControlName="typeOfTDU" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">TDU Charges per Month</label>
        <input
          type="text"
          class="form-control"
          formControlName="tDU_Charges_Month"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">TDU Charges per kWh</label>
        <input
          type="text"
          class="form-control"
          formControlName="tDU_Charges_Kwh"
        />
      </div>
      <!-- <div class="col-md-6">
        <label for="userId" class="control-label">500</label>
        <input
          type="text"
          class="form-control"
          formControlName="five_hundred"
        />
      </div> -->
    </div>
    <!-- <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">1000</label>
        <input type="text" class="form-control" formControlName="thousand" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">2000</label>
        <input
          type="text"
          class="form-control"
          formControlName="two_thousand"
        />
      </div>
    </div> -->
    <!-- <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Daily Charge</label>
        <input
          type="text"
          class="form-control"
          formControlName="daily_Charge"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Energy Price</label>
        <input
          type="text"
          class="form-control"
          formControlName="energy_Price"
        />
      </div>
    </div> -->
    <div class="pull-right mt-2">
      <button
        class="mr-2 mt-0 btn sectbtn brdrRadius"
        (click)="postDataOfNewEnergyProvider()"
      >
        Submit
      </button>
      <button mat-raised-button (click)="closeDialog()">Cancel</button>
    </div>
  </form>
  <!-- <input matInput [(ngModel)]="data.animal"> -->
</div>
<!-- <div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button class="btn btn-primary" (click)="postDataOfNewEnergyProvider()">
    Submit
  </button>
</div> -->
